import React from 'react';
import styled from 'styled-components';
import { Card, Divider } from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import InputBase from '@material-ui/core/InputBase';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import { formatDate } from '../../../common/formatter';

const StyledDate = styled.div`
  padding: 2px 4px;
  display: flex;
  align-items: center;
  width: 400;
  border-style: solid;
  border-color: #6f6f6f;
  border-width: 1px;
  border-radius: 4px;
  color: #6f6f6f;
`;

export interface JiraDueDateCardProps {
  issue: any;
}

const JiraDueDateCard: React.FC<JiraDueDateCardProps> = ({ issue }) => {
  const dueDate = issue.fields.duedate ? formatDate(issue.fields.duedate) : '';
  return (
    <Card>
      <CardTitle style={{ marginBottom: 10 }}>
        <CalendarTodayIcon />
        Due Date
      </CardTitle>
      <Divider />
      <CardContent padding='medium'>
        <label style={{ fontWeight: 500, fontSize: 15 }}>Due Date</label>
        <StyledDate>
          <InputBase style={{ flex: 1 }} value={dueDate} />
          <CalendarTodayIcon />
        </StyledDate>
      </CardContent>
    </Card>
  );
};

export default JiraDueDateCard;
